import {createSlice} from "@reduxjs/toolkit";

const initialDriversState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  activeDrivers: null,
  activeDriversCount: 0,
  driverForEdit: undefined,
  unassignedDrivers: null,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const driversSlice = createSlice({
  name: "drivers",
  initialState: initialDriversState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getDriverById
    driverFetched: (state, action) => {
      state.actionsLoading = false;
      state.driverForEdit = action.payload.driverForEdit;
      state.error = null;
    },
    // findDrivers
    driversFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    //active Drivers
    activeDriversFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.activeDrivers = entities;
      state.activeDriversCount = totalCount;
    },
    // createDriver
    driverCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      if(action.payload.driver !== null){
        var usr = action.payload.driver;
        state.entities.push(usr);
      }
    },
    //unassignedDriversFetched
    unassignedDriversFetched: (state, action) => {
      const {  entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.unassignedDrivers = entities;
    },
    // updateDriver
    driverUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.driver.id) {
          return action.payload.driver;
        }
        return entity;
      });
    },
    // deleteDriver
    driverDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteDrivers
    driversDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // driversUpdateState
    driversStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
